<template lang="pug">
a-entity.loading
  template(v-if="show")
    tutorial(@next="next")
  template(v-else)
    .loader(ref="loader")
      splash(:progress="loading.progress")
      .load-progress
        progress-bar(
           :progress="loading.progress"
          )
      animated-number(:progress="Math.floor(loading.progress*100)")


</template>

<script>
import { focus } from 'vue-focus'
import { mapState, mapMutations } from 'vuex'

// SERVICES
import AssetService from 'src/services/AssetService'
import SoundService from 'src/services/SoundService'
import tutorManifest from 'src/components/manifests/tutorAssets'
import soundManifest from 'src/components/manifests/sounds'

//COMPONENTS
import Tutorial from 'src/components/vca/tutorial/Tutorial'
import Welcome from 'src/components/vca/welcome/Welcome'
import ProgressBar from 'src/components/vca/widgets/ProgressBar2'
import BgPattern from 'src/components/vca/widgets/BgPattern'
import Splash from 'src/components/vca/widgets/Splash'
import AnimatedNumber from 'src/components/vca/widgets/AnimatedNumber'

import * as PATHS from 'src/router/paths'

import {TimelineMax, Power2} from 'gsap'


export default {
  name: 'loading',
  directives: {
    focus: focus,
  },
  components: {
    Tutorial,
    Welcome,
    ProgressBar,
    BgPattern,
    AnimatedNumber,
    Splash

  },
  data() {
    return {
      show: false,
      leaving: false,

      progress: {
        assets: 0,
        media: 0,
        sounds: 0,
      },
      startTime: Date.now(),
      updateTime: 1000 / 30,
      minTime: 1000,

      loading: {
        progress: 0,
        completed: false,
      },
    }
  },
  computed: {


  },
  mounted() {
    window.Loading = this
    this.listen()
    this.load()

  },
  beforeDestroy() {
    this.unlisten()
  },
  methods: {
    ...mapMutations('app', ['setLoadAframe', 'setLoadComplete']),
    listen() {

      this.interval = setInterval(this.update, this.updateTime)
    },
    unlisten() {

      clearInterval(this.interval)
    },
    async load() {
      this.startTime = Date.now()
      AssetService.load(tutorManifest)
      SoundService.load(soundManifest)
      this.setLoadAframe(true)

    },

    update() {
      // Aframe loader
      this.progress.media = AssetService._progress
      this.progress.sounds = SoundService.progress
      this.progress.assets = document.querySelector('a-assets').__vue__.showProgress

      let actualProgress = 0
      actualProgress += this.progress.assets * 0.3
      actualProgress += this.progress.media * 0.3
      actualProgress += this.progress.sounds * 0.4


      let maxProgress = (Date.now() - this.startTime) / this.minTime
      maxProgress = Math.min(maxProgress, 1)

      let showProgress = Math.min(actualProgress, maxProgress)
      showProgress = Math.min(showProgress, 1)

      this.loading.progress = Math.max(this.loading.progress, showProgress)

      if (this.loading.progress >= 1) {

        this.setLoadComplete()
        this.enter()
      }
    },
    enter() {
      this.unlisten()
      let pattern = document.getElementById('loading-bg-container')

      let tl = new TimelineMax({ onComplete: () => {
          this.show = true
          document.body.removeChild(pattern)
        } })
      this.tl = tl


      tl.add('start')
        .to(
          this.$refs.loader,
          1,
          {
            x: -window.innerWidth,
            ease: Power2.easeOut,
          },
          `start+=0`
        )
        .to(
          pattern,
          1,
          {
            x: -window.innerWidth,
            ease: Power2.easeOut,
          },
          `start+=0`
        )



    },
    next() {
      this.$router.replace({
        name: PATHS.WELCOME,

      })


    },


  },
  watch: {

  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.loading
  line-height: 0
  +full()


.loader
  +full()

  .bg
    +full()
    background: linear-gradient(171.36deg, #FD9F02 69.87%, #E68203 112.08%)
    overflow: hidden
    .bg-pattern
      mix-blend-mode: color-burn

.load-progress
  position: absolute
  width: 100%
  bottom: 0
  text-align: center
  z-index: 99
.splash-container
  z-index: 100
.animated-number
  z-index: 99
.logo
  z-index: 99

.welcome
  z-index: 70






</style>
